<input kendoTextBox
  type="text"
  class="k-textbox"
  [formControl]="_inputBarcode"
  [value]="value"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [attr.disabled]="disabled ? 'disabled'  : null"
  required />

  <a class="button-link">@if (_isAutoGeneratingNumber) {
    <img class="gen_icon addplus"
      (click)="generateNumber($event)"
      [src]="icon"
      [class.disabled]="disabled"
      />
  }</a>
